import { useCallback, useEffect, useState } from 'react';
/**
 * Verwaltet den Offen-Zustand der Command-Palette und bindet das globale
 * Tastenkuerzel **Ctrl/Cmd+K** (M365/Google/Spotlight-Konvention). Escape und
 * Auswahl schliessen die Palette in der Komponente selbst.
 */
export function useCommandPalette(enabled = true) {
    const [open, setOpen] = useState(false);
    const openPalette = useCallback(() => setOpen(true), []);
    const closePalette = useCallback(() => setOpen(false), []);
    useEffect(() => {
        if (!enabled || typeof window === 'undefined')
            return;
        const onKey = (e) => {
            if ((e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K')) {
                e.preventDefault();
                setOpen((v) => !v);
            }
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [enabled]);
    return { open, openPalette, closePalette, setOpen };
}
